import {
  jb_podcast_player_css_default
} from "./chunk.3KG2ST3G.js";
import {
  Plyr
} from "./chunk.ENEB5H6X.js";
import {
  e as e2
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  o
} from "./chunk.DJ2G5F2M.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  ChangesBackgroundColor
} from "./chunk.XYH4LHGJ.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  e,
  n,
  r
} from "./chunk.XW2RSTES.js";
import {
  __commonJS,
  __decorateClass,
  __toESM
} from "./chunk.LUIRGYUH.js";

// node_modules/.pnpm/rangetouch@2.0.1/node_modules/rangetouch/dist/rangetouch.js
var require_rangetouch = __commonJS({
  "node_modules/.pnpm/rangetouch@2.0.1/node_modules/rangetouch/dist/rangetouch.js"(exports, module) {
    !(function(e3, t) {
      "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("RangeTouch", t) : (e3 = e3 || self).RangeTouch = t();
    })(exports, (function() {
      "use strict";
      function e3(e4, t2) {
        for (var n3 = 0; n3 < t2.length; n3++) {
          var r3 = t2[n3];
          r3.enumerable = r3.enumerable || false, r3.configurable = true, "value" in r3 && (r3.writable = true), Object.defineProperty(e4, r3.key, r3);
        }
      }
      function t(e4, t2, n3) {
        return t2 in e4 ? Object.defineProperty(e4, t2, { value: n3, enumerable: true, configurable: true, writable: true }) : e4[t2] = n3, e4;
      }
      function n2(e4, t2) {
        var n3 = Object.keys(e4);
        if (Object.getOwnPropertySymbols) {
          var r3 = Object.getOwnPropertySymbols(e4);
          t2 && (r3 = r3.filter((function(t3) {
            return Object.getOwnPropertyDescriptor(e4, t3).enumerable;
          }))), n3.push.apply(n3, r3);
        }
        return n3;
      }
      function r2(e4) {
        for (var r3 = 1; r3 < arguments.length; r3++) {
          var i3 = null != arguments[r3] ? arguments[r3] : {};
          r3 % 2 ? n2(Object(i3), true).forEach((function(n3) {
            t(e4, n3, i3[n3]);
          })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e4, Object.getOwnPropertyDescriptors(i3)) : n2(Object(i3)).forEach((function(t2) {
            Object.defineProperty(e4, t2, Object.getOwnPropertyDescriptor(i3, t2));
          }));
        }
        return e4;
      }
      var i2 = { addCSS: true, thumbWidth: 15, watch: true };
      function u(e4, t2) {
        return function() {
          return Array.from(document.querySelectorAll(t2)).includes(this);
        }.call(e4, t2);
      }
      var o2 = function(e4) {
        return null != e4 ? e4.constructor : null;
      }, c = function(e4, t2) {
        return !!(e4 && t2 && e4 instanceof t2);
      }, l = function(e4) {
        return null == e4;
      }, a = function(e4) {
        return o2(e4) === Object;
      }, s = function(e4) {
        return o2(e4) === String;
      }, f = function(e4) {
        return Array.isArray(e4);
      }, h = function(e4) {
        return c(e4, NodeList);
      }, d = s, y = f, b2 = h, m = function(e4) {
        return c(e4, Element);
      }, g = function(e4) {
        return c(e4, Event);
      }, p = function(e4) {
        return l(e4) || (s(e4) || f(e4) || h(e4)) && !e4.length || a(e4) && !Object.keys(e4).length;
      };
      function v(e4, t2) {
        if (1 > t2) {
          var n3 = (function(e5) {
            var t3 = "".concat(e5).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
            return t3 ? Math.max(0, (t3[1] ? t3[1].length : 0) - (t3[2] ? +t3[2] : 0)) : 0;
          })(t2);
          return parseFloat(e4.toFixed(n3));
        }
        return Math.round(e4 / t2) * t2;
      }
      return (function() {
        function t2(e4, n4) {
          (function(e5, t3) {
            if (!(e5 instanceof t3)) throw new TypeError("Cannot call a class as a function");
          })(this, t2), m(e4) ? this.element = e4 : d(e4) && (this.element = document.querySelector(e4)), m(this.element) && p(this.element.rangeTouch) && (this.config = r2({}, i2, {}, n4), this.init());
        }
        return n3 = t2, c2 = [{ key: "setup", value: function(e4) {
          var n4 = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, o4 = null;
          if (p(e4) || d(e4) ? o4 = Array.from(document.querySelectorAll(d(e4) ? e4 : 'input[type="range"]')) : m(e4) ? o4 = [e4] : b2(e4) ? o4 = Array.from(e4) : y(e4) && (o4 = e4.filter(m)), p(o4)) return null;
          var c3 = r2({}, i2, {}, n4);
          if (d(e4) && c3.watch) {
            var l2 = new MutationObserver((function(n5) {
              Array.from(n5).forEach((function(n6) {
                Array.from(n6.addedNodes).forEach((function(n7) {
                  m(n7) && u(n7, e4) && new t2(n7, c3);
                }));
              }));
            }));
            l2.observe(document.body, { childList: true, subtree: true });
          }
          return o4.map((function(e5) {
            return new t2(e5, n4);
          }));
        } }, { key: "enabled", get: function() {
          return "ontouchstart" in document.documentElement;
        } }], (o3 = [{ key: "init", value: function() {
          t2.enabled && (this.config.addCSS && (this.element.style.userSelect = "none", this.element.style.webKitUserSelect = "none", this.element.style.touchAction = "manipulation"), this.listeners(true), this.element.rangeTouch = this);
        } }, { key: "destroy", value: function() {
          t2.enabled && (this.config.addCSS && (this.element.style.userSelect = "", this.element.style.webKitUserSelect = "", this.element.style.touchAction = ""), this.listeners(false), this.element.rangeTouch = null);
        } }, { key: "listeners", value: function(e4) {
          var t3 = this, n4 = e4 ? "addEventListener" : "removeEventListener";
          ["touchstart", "touchmove", "touchend"].forEach((function(e5) {
            t3.element[n4](e5, (function(e6) {
              return t3.set(e6);
            }), false);
          }));
        } }, { key: "get", value: function(e4) {
          if (!t2.enabled || !g(e4)) return null;
          var n4, r3 = e4.target, i3 = e4.changedTouches[0], u2 = parseFloat(r3.getAttribute("min")) || 0, o4 = parseFloat(r3.getAttribute("max")) || 100, c3 = parseFloat(r3.getAttribute("step")) || 1, l2 = r3.getBoundingClientRect(), a2 = 100 / l2.width * (this.config.thumbWidth / 2) / 100;
          return 0 > (n4 = 100 / l2.width * (i3.clientX - l2.left)) ? n4 = 0 : 100 < n4 && (n4 = 100), 50 > n4 ? n4 -= (100 - 2 * n4) * a2 : 50 < n4 && (n4 += 2 * (n4 - 50) * a2), u2 + v(n4 / 100 * (o4 - u2), c3);
        } }, { key: "set", value: function(e4) {
          t2.enabled && g(e4) && !e4.target.disabled && (e4.preventDefault(), e4.target.value = this.get(e4), (function(e5, t3) {
            if (e5 && t3) {
              var n4 = new Event(t3, { bubbles: true });
              e5.dispatchEvent(n4);
            }
          })(e4.target, "touchend" === e4.type ? "change" : "input"));
        } }]) && e3(n3.prototype, o3), c2 && e3(n3, c2), t2;
        var n3, o3, c2;
      })();
    }));
  }
});

// src/components/jb-podcast-player/jb-podcast-player.ts
var import_rangetouch = __toESM(require_rangetouch(), 1);

// node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/isObject.js
function isObject(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var isObject_default = isObject;

// node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_freeGlobal.js
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
var freeGlobal_default = freeGlobal;

// node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_root.js
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal_default || freeSelf || Function("return this")();
var root_default = root;

// node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/now.js
var now = function() {
  return root_default.Date.now();
};
var now_default = now;

// node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_trimmedEndIndex.js
var reWhitespace = /\s/;
function trimmedEndIndex(string) {
  var index = string.length;
  while (index-- && reWhitespace.test(string.charAt(index))) {
  }
  return index;
}
var trimmedEndIndex_default = trimmedEndIndex;

// node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_baseTrim.js
var reTrimStart = /^\s+/;
function baseTrim(string) {
  return string ? string.slice(0, trimmedEndIndex_default(string) + 1).replace(reTrimStart, "") : string;
}
var baseTrim_default = baseTrim;

// node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_Symbol.js
var Symbol = root_default.Symbol;
var Symbol_default = Symbol;

// node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_getRawTag.js
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
var nativeObjectToString = objectProto.toString;
var symToStringTag = Symbol_default ? Symbol_default.toStringTag : void 0;
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
  try {
    value[symToStringTag] = void 0;
    var unmasked = true;
  } catch (e3) {
  }
  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}
var getRawTag_default = getRawTag;

// node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_objectToString.js
var objectProto2 = Object.prototype;
var nativeObjectToString2 = objectProto2.toString;
function objectToString(value) {
  return nativeObjectToString2.call(value);
}
var objectToString_default = objectToString;

// node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/_baseGetTag.js
var nullTag = "[object Null]";
var undefinedTag = "[object Undefined]";
var symToStringTag2 = Symbol_default ? Symbol_default.toStringTag : void 0;
function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag2 && symToStringTag2 in Object(value) ? getRawTag_default(value) : objectToString_default(value);
}
var baseGetTag_default = baseGetTag;

// node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/isObjectLike.js
function isObjectLike(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_default = isObjectLike;

// node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/isSymbol.js
var symbolTag = "[object Symbol]";
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike_default(value) && baseGetTag_default(value) == symbolTag;
}
var isSymbol_default = isSymbol;

// node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/toNumber.js
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol_default(value)) {
    return NAN;
  }
  if (isObject_default(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject_default(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim_default(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var toNumber_default = toNumber;

// node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/debounce.js
var FUNC_ERROR_TEXT = "Expected a function";
var nativeMax = Math.max;
var nativeMin = Math.min;
function debounce(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber_default(wait) || 0;
  if (isObject_default(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber_default(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now_default();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now_default());
  }
  function debounced() {
    var time = now_default(), isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var debounce_default = debounce;

// node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es/throttle.js
var FUNC_ERROR_TEXT2 = "Expected a function";
function throttle(func, wait, options) {
  var leading = true, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT2);
  }
  if (isObject_default(options)) {
    leading = "leading" in options ? !!options.leading : leading;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  return debounce_default(func, wait, {
    "leading": leading,
    "maxWait": wait,
    "trailing": trailing
  });
}
var throttle_default = throttle;

// node_modules/.pnpm/simplebar-core@1.3.2/node_modules/simplebar-core/dist/index.mjs
var __assign = function() {
  __assign = Object.assign || function __assign2(t) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function getElementWindow$1(element) {
  if (!element || !element.ownerDocument || !element.ownerDocument.defaultView) {
    return window;
  }
  return element.ownerDocument.defaultView;
}
function getElementDocument$1(element) {
  if (!element || !element.ownerDocument) {
    return document;
  }
  return element.ownerDocument;
}
var getOptions$1 = function(obj) {
  var initialObj = {};
  var options = Array.prototype.reduce.call(obj, function(acc, attribute) {
    var option = attribute.name.match(/data-simplebar-(.+)/);
    if (option) {
      var key = option[1].replace(/\W+(.)/g, function(_, chr) {
        return chr.toUpperCase();
      });
      switch (attribute.value) {
        case "true":
          acc[key] = true;
          break;
        case "false":
          acc[key] = false;
          break;
        case void 0:
          acc[key] = true;
          break;
        default:
          acc[key] = attribute.value;
      }
    }
    return acc;
  }, initialObj);
  return options;
};
function addClasses$1(el, classes) {
  var _a2;
  if (!el)
    return;
  (_a2 = el.classList).add.apply(_a2, classes.split(" "));
}
function removeClasses$1(el, classes) {
  if (!el)
    return;
  classes.split(" ").forEach(function(className) {
    el.classList.remove(className);
  });
}
function classNamesToQuery$1(classNames) {
  return ".".concat(classNames.split(" ").join("."));
}
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var helpers = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  addClasses: addClasses$1,
  canUseDOM,
  classNamesToQuery: classNamesToQuery$1,
  getElementDocument: getElementDocument$1,
  getElementWindow: getElementWindow$1,
  getOptions: getOptions$1,
  removeClasses: removeClasses$1
});
var cachedScrollbarWidth = null;
var cachedDevicePixelRatio = null;
if (canUseDOM) {
  window.addEventListener("resize", function() {
    if (cachedDevicePixelRatio !== window.devicePixelRatio) {
      cachedDevicePixelRatio = window.devicePixelRatio;
      cachedScrollbarWidth = null;
    }
  });
}
function scrollbarWidth() {
  if (cachedScrollbarWidth === null) {
    if (typeof document === "undefined") {
      cachedScrollbarWidth = 0;
      return cachedScrollbarWidth;
    }
    var body = document.body;
    var box = document.createElement("div");
    box.classList.add("simplebar-hide-scrollbar");
    body.appendChild(box);
    var width = box.getBoundingClientRect().right;
    body.removeChild(box);
    cachedScrollbarWidth = width;
  }
  return cachedScrollbarWidth;
}
var getElementWindow = getElementWindow$1;
var getElementDocument = getElementDocument$1;
var getOptions = getOptions$1;
var addClasses = addClasses$1;
var removeClasses = removeClasses$1;
var classNamesToQuery = classNamesToQuery$1;
var SimpleBarCore = (
  /** @class */
  (function() {
    function SimpleBarCore2(element, options) {
      if (options === void 0) {
        options = {};
      }
      var _this = this;
      this.removePreventClickId = null;
      this.minScrollbarWidth = 20;
      this.stopScrollDelay = 175;
      this.isScrolling = false;
      this.isMouseEntering = false;
      this.isDragging = false;
      this.scrollXTicking = false;
      this.scrollYTicking = false;
      this.wrapperEl = null;
      this.contentWrapperEl = null;
      this.contentEl = null;
      this.offsetEl = null;
      this.maskEl = null;
      this.placeholderEl = null;
      this.heightAutoObserverWrapperEl = null;
      this.heightAutoObserverEl = null;
      this.rtlHelpers = null;
      this.scrollbarWidth = 0;
      this.resizeObserver = null;
      this.mutationObserver = null;
      this.elStyles = null;
      this.isRtl = null;
      this.mouseX = 0;
      this.mouseY = 0;
      this.onMouseMove = function() {
      };
      this.onWindowResize = function() {
      };
      this.onStopScrolling = function() {
      };
      this.onMouseEntered = function() {
      };
      this.onScroll = function() {
        var elWindow = getElementWindow(_this.el);
        if (!_this.scrollXTicking) {
          elWindow.requestAnimationFrame(_this.scrollX);
          _this.scrollXTicking = true;
        }
        if (!_this.scrollYTicking) {
          elWindow.requestAnimationFrame(_this.scrollY);
          _this.scrollYTicking = true;
        }
        if (!_this.isScrolling) {
          _this.isScrolling = true;
          addClasses(_this.el, _this.classNames.scrolling);
        }
        _this.showScrollbar("x");
        _this.showScrollbar("y");
        _this.onStopScrolling();
      };
      this.scrollX = function() {
        if (_this.axis.x.isOverflowing) {
          _this.positionScrollbar("x");
        }
        _this.scrollXTicking = false;
      };
      this.scrollY = function() {
        if (_this.axis.y.isOverflowing) {
          _this.positionScrollbar("y");
        }
        _this.scrollYTicking = false;
      };
      this._onStopScrolling = function() {
        removeClasses(_this.el, _this.classNames.scrolling);
        if (_this.options.autoHide) {
          _this.hideScrollbar("x");
          _this.hideScrollbar("y");
        }
        _this.isScrolling = false;
      };
      this.onMouseEnter = function() {
        if (!_this.isMouseEntering) {
          addClasses(_this.el, _this.classNames.mouseEntered);
          _this.showScrollbar("x");
          _this.showScrollbar("y");
          _this.isMouseEntering = true;
        }
        _this.onMouseEntered();
      };
      this._onMouseEntered = function() {
        removeClasses(_this.el, _this.classNames.mouseEntered);
        if (_this.options.autoHide) {
          _this.hideScrollbar("x");
          _this.hideScrollbar("y");
        }
        _this.isMouseEntering = false;
      };
      this._onMouseMove = function(e3) {
        _this.mouseX = e3.clientX;
        _this.mouseY = e3.clientY;
        if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) {
          _this.onMouseMoveForAxis("x");
        }
        if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) {
          _this.onMouseMoveForAxis("y");
        }
      };
      this.onMouseLeave = function() {
        _this.onMouseMove.cancel();
        if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) {
          _this.onMouseLeaveForAxis("x");
        }
        if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) {
          _this.onMouseLeaveForAxis("y");
        }
        _this.mouseX = -1;
        _this.mouseY = -1;
      };
      this._onWindowResize = function() {
        _this.scrollbarWidth = _this.getScrollbarWidth();
        _this.hideNativeScrollbar();
      };
      this.onPointerEvent = function(e3) {
        if (!_this.axis.x.track.el || !_this.axis.y.track.el || !_this.axis.x.scrollbar.el || !_this.axis.y.scrollbar.el)
          return;
        var isWithinTrackXBounds, isWithinTrackYBounds;
        _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
        _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
        if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) {
          isWithinTrackXBounds = _this.isWithinBounds(_this.axis.x.track.rect);
        }
        if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) {
          isWithinTrackYBounds = _this.isWithinBounds(_this.axis.y.track.rect);
        }
        if (isWithinTrackXBounds || isWithinTrackYBounds) {
          e3.stopPropagation();
          if (e3.type === "pointerdown" && e3.pointerType !== "touch") {
            if (isWithinTrackXBounds) {
              _this.axis.x.scrollbar.rect = _this.axis.x.scrollbar.el.getBoundingClientRect();
              if (_this.isWithinBounds(_this.axis.x.scrollbar.rect)) {
                _this.onDragStart(e3, "x");
              } else {
                _this.onTrackClick(e3, "x");
              }
            }
            if (isWithinTrackYBounds) {
              _this.axis.y.scrollbar.rect = _this.axis.y.scrollbar.el.getBoundingClientRect();
              if (_this.isWithinBounds(_this.axis.y.scrollbar.rect)) {
                _this.onDragStart(e3, "y");
              } else {
                _this.onTrackClick(e3, "y");
              }
            }
          }
        }
      };
      this.drag = function(e3) {
        var _a2, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (!_this.draggedAxis || !_this.contentWrapperEl)
          return;
        var eventOffset;
        var track = _this.axis[_this.draggedAxis].track;
        var trackSize = (_b = (_a2 = track.rect) === null || _a2 === void 0 ? void 0 : _a2[_this.axis[_this.draggedAxis].sizeAttr]) !== null && _b !== void 0 ? _b : 0;
        var scrollbar = _this.axis[_this.draggedAxis].scrollbar;
        var contentSize = (_d = (_c = _this.contentWrapperEl) === null || _c === void 0 ? void 0 : _c[_this.axis[_this.draggedAxis].scrollSizeAttr]) !== null && _d !== void 0 ? _d : 0;
        var hostSize = parseInt((_f = (_e = _this.elStyles) === null || _e === void 0 ? void 0 : _e[_this.axis[_this.draggedAxis].sizeAttr]) !== null && _f !== void 0 ? _f : "0px", 10);
        e3.preventDefault();
        e3.stopPropagation();
        if (_this.draggedAxis === "y") {
          eventOffset = e3.pageY;
        } else {
          eventOffset = e3.pageX;
        }
        var dragPos = eventOffset - ((_h = (_g = track.rect) === null || _g === void 0 ? void 0 : _g[_this.axis[_this.draggedAxis].offsetAttr]) !== null && _h !== void 0 ? _h : 0) - _this.axis[_this.draggedAxis].dragOffset;
        dragPos = _this.draggedAxis === "x" && _this.isRtl ? ((_k = (_j = track.rect) === null || _j === void 0 ? void 0 : _j[_this.axis[_this.draggedAxis].sizeAttr]) !== null && _k !== void 0 ? _k : 0) - scrollbar.size - dragPos : dragPos;
        var dragPerc = dragPos / (trackSize - scrollbar.size);
        var scrollPos = dragPerc * (contentSize - hostSize);
        if (_this.draggedAxis === "x" && _this.isRtl) {
          scrollPos = ((_l = SimpleBarCore2.getRtlHelpers()) === null || _l === void 0 ? void 0 : _l.isScrollingToNegative) ? -scrollPos : scrollPos;
        }
        _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollOffsetAttr] = scrollPos;
      };
      this.onEndDrag = function(e3) {
        _this.isDragging = false;
        var elDocument = getElementDocument(_this.el);
        var elWindow = getElementWindow(_this.el);
        e3.preventDefault();
        e3.stopPropagation();
        removeClasses(_this.el, _this.classNames.dragging);
        _this.onStopScrolling();
        elDocument.removeEventListener("mousemove", _this.drag, true);
        elDocument.removeEventListener("mouseup", _this.onEndDrag, true);
        _this.removePreventClickId = elWindow.setTimeout(function() {
          elDocument.removeEventListener("click", _this.preventClick, true);
          elDocument.removeEventListener("dblclick", _this.preventClick, true);
          _this.removePreventClickId = null;
        });
      };
      this.preventClick = function(e3) {
        e3.preventDefault();
        e3.stopPropagation();
      };
      this.el = element;
      this.options = __assign(__assign({}, SimpleBarCore2.defaultOptions), options);
      this.classNames = __assign(__assign({}, SimpleBarCore2.defaultOptions.classNames), options.classNames);
      this.axis = {
        x: {
          scrollOffsetAttr: "scrollLeft",
          sizeAttr: "width",
          scrollSizeAttr: "scrollWidth",
          offsetSizeAttr: "offsetWidth",
          offsetAttr: "left",
          overflowAttr: "overflowX",
          dragOffset: 0,
          isOverflowing: true,
          forceVisible: false,
          track: { size: null, el: null, rect: null, isVisible: false },
          scrollbar: { size: null, el: null, rect: null, isVisible: false }
        },
        y: {
          scrollOffsetAttr: "scrollTop",
          sizeAttr: "height",
          scrollSizeAttr: "scrollHeight",
          offsetSizeAttr: "offsetHeight",
          offsetAttr: "top",
          overflowAttr: "overflowY",
          dragOffset: 0,
          isOverflowing: true,
          forceVisible: false,
          track: { size: null, el: null, rect: null, isVisible: false },
          scrollbar: { size: null, el: null, rect: null, isVisible: false }
        }
      };
      if (typeof this.el !== "object" || !this.el.nodeName) {
        throw new Error("Argument passed to SimpleBar must be an HTML element instead of ".concat(this.el));
      }
      this.onMouseMove = throttle_default(this._onMouseMove, 64);
      this.onWindowResize = debounce_default(this._onWindowResize, 64, { leading: true });
      this.onStopScrolling = debounce_default(this._onStopScrolling, this.stopScrollDelay);
      this.onMouseEntered = debounce_default(this._onMouseEntered, this.stopScrollDelay);
      this.init();
    }
    SimpleBarCore2.getRtlHelpers = function() {
      if (SimpleBarCore2.rtlHelpers) {
        return SimpleBarCore2.rtlHelpers;
      }
      var dummyDiv = document.createElement("div");
      dummyDiv.innerHTML = '<div class="simplebar-dummy-scrollbar-size"><div></div></div>';
      var scrollbarDummyEl = dummyDiv.firstElementChild;
      var dummyChild = scrollbarDummyEl === null || scrollbarDummyEl === void 0 ? void 0 : scrollbarDummyEl.firstElementChild;
      if (!dummyChild)
        return null;
      document.body.appendChild(scrollbarDummyEl);
      scrollbarDummyEl.scrollLeft = 0;
      var dummyContainerOffset = SimpleBarCore2.getOffset(scrollbarDummyEl);
      var dummyChildOffset = SimpleBarCore2.getOffset(dummyChild);
      scrollbarDummyEl.scrollLeft = -999;
      var dummyChildOffsetAfterScroll = SimpleBarCore2.getOffset(dummyChild);
      document.body.removeChild(scrollbarDummyEl);
      SimpleBarCore2.rtlHelpers = {
        // determines if the scrolling is responding with negative values
        isScrollOriginAtZero: dummyContainerOffset.left !== dummyChildOffset.left,
        // determines if the origin scrollbar position is inverted or not (positioned on left or right)
        isScrollingToNegative: dummyChildOffset.left !== dummyChildOffsetAfterScroll.left
      };
      return SimpleBarCore2.rtlHelpers;
    };
    SimpleBarCore2.prototype.getScrollbarWidth = function() {
      try {
        if (this.contentWrapperEl && getComputedStyle(this.contentWrapperEl, "::-webkit-scrollbar").display === "none" || "scrollbarWidth" in document.documentElement.style || "-ms-overflow-style" in document.documentElement.style) {
          return 0;
        } else {
          return scrollbarWidth();
        }
      } catch (e3) {
        return scrollbarWidth();
      }
    };
    SimpleBarCore2.getOffset = function(el) {
      var rect = el.getBoundingClientRect();
      var elDocument = getElementDocument(el);
      var elWindow = getElementWindow(el);
      return {
        top: rect.top + (elWindow.pageYOffset || elDocument.documentElement.scrollTop),
        left: rect.left + (elWindow.pageXOffset || elDocument.documentElement.scrollLeft)
      };
    };
    SimpleBarCore2.prototype.init = function() {
      if (canUseDOM) {
        this.initDOM();
        this.rtlHelpers = SimpleBarCore2.getRtlHelpers();
        this.scrollbarWidth = this.getScrollbarWidth();
        this.recalculate();
        this.initListeners();
      }
    };
    SimpleBarCore2.prototype.initDOM = function() {
      var _a2, _b;
      this.wrapperEl = this.el.querySelector(classNamesToQuery(this.classNames.wrapper));
      this.contentWrapperEl = this.options.scrollableNode || this.el.querySelector(classNamesToQuery(this.classNames.contentWrapper));
      this.contentEl = this.options.contentNode || this.el.querySelector(classNamesToQuery(this.classNames.contentEl));
      this.offsetEl = this.el.querySelector(classNamesToQuery(this.classNames.offset));
      this.maskEl = this.el.querySelector(classNamesToQuery(this.classNames.mask));
      this.placeholderEl = this.findChild(this.wrapperEl, classNamesToQuery(this.classNames.placeholder));
      this.heightAutoObserverWrapperEl = this.el.querySelector(classNamesToQuery(this.classNames.heightAutoObserverWrapperEl));
      this.heightAutoObserverEl = this.el.querySelector(classNamesToQuery(this.classNames.heightAutoObserverEl));
      this.axis.x.track.el = this.findChild(this.el, "".concat(classNamesToQuery(this.classNames.track)).concat(classNamesToQuery(this.classNames.horizontal)));
      this.axis.y.track.el = this.findChild(this.el, "".concat(classNamesToQuery(this.classNames.track)).concat(classNamesToQuery(this.classNames.vertical)));
      this.axis.x.scrollbar.el = ((_a2 = this.axis.x.track.el) === null || _a2 === void 0 ? void 0 : _a2.querySelector(classNamesToQuery(this.classNames.scrollbar))) || null;
      this.axis.y.scrollbar.el = ((_b = this.axis.y.track.el) === null || _b === void 0 ? void 0 : _b.querySelector(classNamesToQuery(this.classNames.scrollbar))) || null;
      if (!this.options.autoHide) {
        addClasses(this.axis.x.scrollbar.el, this.classNames.visible);
        addClasses(this.axis.y.scrollbar.el, this.classNames.visible);
      }
    };
    SimpleBarCore2.prototype.initListeners = function() {
      var _this = this;
      var _a2;
      var elWindow = getElementWindow(this.el);
      this.el.addEventListener("mouseenter", this.onMouseEnter);
      this.el.addEventListener("pointerdown", this.onPointerEvent, true);
      this.el.addEventListener("mousemove", this.onMouseMove);
      this.el.addEventListener("mouseleave", this.onMouseLeave);
      (_a2 = this.contentWrapperEl) === null || _a2 === void 0 ? void 0 : _a2.addEventListener("scroll", this.onScroll);
      elWindow.addEventListener("resize", this.onWindowResize);
      if (!this.contentEl)
        return;
      if (window.ResizeObserver) {
        var resizeObserverStarted_1 = false;
        var resizeObserver = elWindow.ResizeObserver || ResizeObserver;
        this.resizeObserver = new resizeObserver(function() {
          if (!resizeObserverStarted_1)
            return;
          elWindow.requestAnimationFrame(function() {
            _this.recalculate();
          });
        });
        this.resizeObserver.observe(this.el);
        this.resizeObserver.observe(this.contentEl);
        elWindow.requestAnimationFrame(function() {
          resizeObserverStarted_1 = true;
        });
      }
      this.mutationObserver = new elWindow.MutationObserver(function() {
        elWindow.requestAnimationFrame(function() {
          _this.recalculate();
        });
      });
      this.mutationObserver.observe(this.contentEl, {
        childList: true,
        subtree: true,
        characterData: true
      });
    };
    SimpleBarCore2.prototype.recalculate = function() {
      if (!this.heightAutoObserverEl || !this.contentEl || !this.contentWrapperEl || !this.wrapperEl || !this.placeholderEl)
        return;
      var elWindow = getElementWindow(this.el);
      this.elStyles = elWindow.getComputedStyle(this.el);
      this.isRtl = this.elStyles.direction === "rtl";
      var contentElOffsetWidth = this.contentEl.offsetWidth;
      var isHeightAuto = this.heightAutoObserverEl.offsetHeight <= 1;
      var isWidthAuto = this.heightAutoObserverEl.offsetWidth <= 1 || contentElOffsetWidth > 0;
      var contentWrapperElOffsetWidth = this.contentWrapperEl.offsetWidth;
      var elOverflowX = this.elStyles.overflowX;
      var elOverflowY = this.elStyles.overflowY;
      this.contentEl.style.padding = "".concat(this.elStyles.paddingTop, " ").concat(this.elStyles.paddingRight, " ").concat(this.elStyles.paddingBottom, " ").concat(this.elStyles.paddingLeft);
      this.wrapperEl.style.margin = "-".concat(this.elStyles.paddingTop, " -").concat(this.elStyles.paddingRight, " -").concat(this.elStyles.paddingBottom, " -").concat(this.elStyles.paddingLeft);
      var contentElScrollHeight = this.contentEl.scrollHeight;
      var contentElScrollWidth = this.contentEl.scrollWidth;
      this.contentWrapperEl.style.height = isHeightAuto ? "auto" : "100%";
      this.placeholderEl.style.width = isWidthAuto ? "".concat(contentElOffsetWidth || contentElScrollWidth, "px") : "auto";
      this.placeholderEl.style.height = "".concat(contentElScrollHeight, "px");
      var contentWrapperElOffsetHeight = this.contentWrapperEl.offsetHeight;
      this.axis.x.isOverflowing = contentElOffsetWidth !== 0 && contentElScrollWidth > contentElOffsetWidth;
      this.axis.y.isOverflowing = contentElScrollHeight > contentWrapperElOffsetHeight;
      this.axis.x.isOverflowing = elOverflowX === "hidden" ? false : this.axis.x.isOverflowing;
      this.axis.y.isOverflowing = elOverflowY === "hidden" ? false : this.axis.y.isOverflowing;
      this.axis.x.forceVisible = this.options.forceVisible === "x" || this.options.forceVisible === true;
      this.axis.y.forceVisible = this.options.forceVisible === "y" || this.options.forceVisible === true;
      this.hideNativeScrollbar();
      var offsetForXScrollbar = this.axis.x.isOverflowing ? this.scrollbarWidth : 0;
      var offsetForYScrollbar = this.axis.y.isOverflowing ? this.scrollbarWidth : 0;
      this.axis.x.isOverflowing = this.axis.x.isOverflowing && contentElScrollWidth > contentWrapperElOffsetWidth - offsetForYScrollbar;
      this.axis.y.isOverflowing = this.axis.y.isOverflowing && contentElScrollHeight > contentWrapperElOffsetHeight - offsetForXScrollbar;
      this.axis.x.scrollbar.size = this.getScrollbarSize("x");
      this.axis.y.scrollbar.size = this.getScrollbarSize("y");
      if (this.axis.x.scrollbar.el)
        this.axis.x.scrollbar.el.style.width = "".concat(this.axis.x.scrollbar.size, "px");
      if (this.axis.y.scrollbar.el)
        this.axis.y.scrollbar.el.style.height = "".concat(this.axis.y.scrollbar.size, "px");
      this.positionScrollbar("x");
      this.positionScrollbar("y");
      this.toggleTrackVisibility("x");
      this.toggleTrackVisibility("y");
    };
    SimpleBarCore2.prototype.getScrollbarSize = function(axis) {
      var _a2, _b;
      if (axis === void 0) {
        axis = "y";
      }
      if (!this.axis[axis].isOverflowing || !this.contentEl) {
        return 0;
      }
      var contentSize = this.contentEl[this.axis[axis].scrollSizeAttr];
      var trackSize = (_b = (_a2 = this.axis[axis].track.el) === null || _a2 === void 0 ? void 0 : _a2[this.axis[axis].offsetSizeAttr]) !== null && _b !== void 0 ? _b : 0;
      var scrollbarRatio = trackSize / contentSize;
      var scrollbarSize;
      scrollbarSize = Math.max(~~(scrollbarRatio * trackSize), this.options.scrollbarMinSize);
      if (this.options.scrollbarMaxSize) {
        scrollbarSize = Math.min(scrollbarSize, this.options.scrollbarMaxSize);
      }
      return scrollbarSize;
    };
    SimpleBarCore2.prototype.positionScrollbar = function(axis) {
      var _a2, _b, _c;
      if (axis === void 0) {
        axis = "y";
      }
      var scrollbar = this.axis[axis].scrollbar;
      if (!this.axis[axis].isOverflowing || !this.contentWrapperEl || !scrollbar.el || !this.elStyles) {
        return;
      }
      var contentSize = this.contentWrapperEl[this.axis[axis].scrollSizeAttr];
      var trackSize = ((_a2 = this.axis[axis].track.el) === null || _a2 === void 0 ? void 0 : _a2[this.axis[axis].offsetSizeAttr]) || 0;
      var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
      var scrollOffset = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
      scrollOffset = axis === "x" && this.isRtl && ((_b = SimpleBarCore2.getRtlHelpers()) === null || _b === void 0 ? void 0 : _b.isScrollOriginAtZero) ? -scrollOffset : scrollOffset;
      if (axis === "x" && this.isRtl) {
        scrollOffset = ((_c = SimpleBarCore2.getRtlHelpers()) === null || _c === void 0 ? void 0 : _c.isScrollingToNegative) ? scrollOffset : -scrollOffset;
      }
      var scrollPourcent = scrollOffset / (contentSize - hostSize);
      var handleOffset = ~~((trackSize - scrollbar.size) * scrollPourcent);
      handleOffset = axis === "x" && this.isRtl ? -handleOffset + (trackSize - scrollbar.size) : handleOffset;
      scrollbar.el.style.transform = axis === "x" ? "translate3d(".concat(handleOffset, "px, 0, 0)") : "translate3d(0, ".concat(handleOffset, "px, 0)");
    };
    SimpleBarCore2.prototype.toggleTrackVisibility = function(axis) {
      if (axis === void 0) {
        axis = "y";
      }
      var track = this.axis[axis].track.el;
      var scrollbar = this.axis[axis].scrollbar.el;
      if (!track || !scrollbar || !this.contentWrapperEl)
        return;
      if (this.axis[axis].isOverflowing || this.axis[axis].forceVisible) {
        track.style.visibility = "visible";
        this.contentWrapperEl.style[this.axis[axis].overflowAttr] = "scroll";
        this.el.classList.add("".concat(this.classNames.scrollable, "-").concat(axis));
      } else {
        track.style.visibility = "hidden";
        this.contentWrapperEl.style[this.axis[axis].overflowAttr] = "hidden";
        this.el.classList.remove("".concat(this.classNames.scrollable, "-").concat(axis));
      }
      if (this.axis[axis].isOverflowing) {
        scrollbar.style.display = "block";
      } else {
        scrollbar.style.display = "none";
      }
    };
    SimpleBarCore2.prototype.showScrollbar = function(axis) {
      if (axis === void 0) {
        axis = "y";
      }
      if (this.axis[axis].isOverflowing && !this.axis[axis].scrollbar.isVisible) {
        addClasses(this.axis[axis].scrollbar.el, this.classNames.visible);
        this.axis[axis].scrollbar.isVisible = true;
      }
    };
    SimpleBarCore2.prototype.hideScrollbar = function(axis) {
      if (axis === void 0) {
        axis = "y";
      }
      if (this.isDragging)
        return;
      if (this.axis[axis].isOverflowing && this.axis[axis].scrollbar.isVisible) {
        removeClasses(this.axis[axis].scrollbar.el, this.classNames.visible);
        this.axis[axis].scrollbar.isVisible = false;
      }
    };
    SimpleBarCore2.prototype.hideNativeScrollbar = function() {
      if (!this.offsetEl)
        return;
      this.offsetEl.style[this.isRtl ? "left" : "right"] = this.axis.y.isOverflowing || this.axis.y.forceVisible ? "-".concat(this.scrollbarWidth, "px") : "0px";
      this.offsetEl.style.bottom = this.axis.x.isOverflowing || this.axis.x.forceVisible ? "-".concat(this.scrollbarWidth, "px") : "0px";
    };
    SimpleBarCore2.prototype.onMouseMoveForAxis = function(axis) {
      if (axis === void 0) {
        axis = "y";
      }
      var currentAxis = this.axis[axis];
      if (!currentAxis.track.el || !currentAxis.scrollbar.el)
        return;
      currentAxis.track.rect = currentAxis.track.el.getBoundingClientRect();
      currentAxis.scrollbar.rect = currentAxis.scrollbar.el.getBoundingClientRect();
      if (this.isWithinBounds(currentAxis.track.rect)) {
        this.showScrollbar(axis);
        addClasses(currentAxis.track.el, this.classNames.hover);
        if (this.isWithinBounds(currentAxis.scrollbar.rect)) {
          addClasses(currentAxis.scrollbar.el, this.classNames.hover);
        } else {
          removeClasses(currentAxis.scrollbar.el, this.classNames.hover);
        }
      } else {
        removeClasses(currentAxis.track.el, this.classNames.hover);
        if (this.options.autoHide) {
          this.hideScrollbar(axis);
        }
      }
    };
    SimpleBarCore2.prototype.onMouseLeaveForAxis = function(axis) {
      if (axis === void 0) {
        axis = "y";
      }
      removeClasses(this.axis[axis].track.el, this.classNames.hover);
      removeClasses(this.axis[axis].scrollbar.el, this.classNames.hover);
      if (this.options.autoHide) {
        this.hideScrollbar(axis);
      }
    };
    SimpleBarCore2.prototype.onDragStart = function(e3, axis) {
      var _a2;
      if (axis === void 0) {
        axis = "y";
      }
      this.isDragging = true;
      var elDocument = getElementDocument(this.el);
      var elWindow = getElementWindow(this.el);
      var scrollbar = this.axis[axis].scrollbar;
      var eventOffset = axis === "y" ? e3.pageY : e3.pageX;
      this.axis[axis].dragOffset = eventOffset - (((_a2 = scrollbar.rect) === null || _a2 === void 0 ? void 0 : _a2[this.axis[axis].offsetAttr]) || 0);
      this.draggedAxis = axis;
      addClasses(this.el, this.classNames.dragging);
      elDocument.addEventListener("mousemove", this.drag, true);
      elDocument.addEventListener("mouseup", this.onEndDrag, true);
      if (this.removePreventClickId === null) {
        elDocument.addEventListener("click", this.preventClick, true);
        elDocument.addEventListener("dblclick", this.preventClick, true);
      } else {
        elWindow.clearTimeout(this.removePreventClickId);
        this.removePreventClickId = null;
      }
    };
    SimpleBarCore2.prototype.onTrackClick = function(e3, axis) {
      var _this = this;
      var _a2, _b, _c, _d;
      if (axis === void 0) {
        axis = "y";
      }
      var currentAxis = this.axis[axis];
      if (!this.options.clickOnTrack || !currentAxis.scrollbar.el || !this.contentWrapperEl)
        return;
      e3.preventDefault();
      var elWindow = getElementWindow(this.el);
      this.axis[axis].scrollbar.rect = currentAxis.scrollbar.el.getBoundingClientRect();
      var scrollbar = this.axis[axis].scrollbar;
      var scrollbarOffset = (_b = (_a2 = scrollbar.rect) === null || _a2 === void 0 ? void 0 : _a2[this.axis[axis].offsetAttr]) !== null && _b !== void 0 ? _b : 0;
      var hostSize = parseInt((_d = (_c = this.elStyles) === null || _c === void 0 ? void 0 : _c[this.axis[axis].sizeAttr]) !== null && _d !== void 0 ? _d : "0px", 10);
      var scrolled = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
      var t = axis === "y" ? this.mouseY - scrollbarOffset : this.mouseX - scrollbarOffset;
      var dir = t < 0 ? -1 : 1;
      var scrollSize = dir === -1 ? scrolled - hostSize : scrolled + hostSize;
      var speed = 40;
      var scrollTo = function() {
        if (!_this.contentWrapperEl)
          return;
        if (dir === -1) {
          if (scrolled > scrollSize) {
            scrolled -= speed;
            _this.contentWrapperEl[_this.axis[axis].scrollOffsetAttr] = scrolled;
            elWindow.requestAnimationFrame(scrollTo);
          }
        } else {
          if (scrolled < scrollSize) {
            scrolled += speed;
            _this.contentWrapperEl[_this.axis[axis].scrollOffsetAttr] = scrolled;
            elWindow.requestAnimationFrame(scrollTo);
          }
        }
      };
      scrollTo();
    };
    SimpleBarCore2.prototype.getContentElement = function() {
      return this.contentEl;
    };
    SimpleBarCore2.prototype.getScrollElement = function() {
      return this.contentWrapperEl;
    };
    SimpleBarCore2.prototype.removeListeners = function() {
      var elWindow = getElementWindow(this.el);
      this.el.removeEventListener("mouseenter", this.onMouseEnter);
      this.el.removeEventListener("pointerdown", this.onPointerEvent, true);
      this.el.removeEventListener("mousemove", this.onMouseMove);
      this.el.removeEventListener("mouseleave", this.onMouseLeave);
      if (this.contentWrapperEl) {
        this.contentWrapperEl.removeEventListener("scroll", this.onScroll);
      }
      elWindow.removeEventListener("resize", this.onWindowResize);
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
      this.onMouseMove.cancel();
      this.onWindowResize.cancel();
      this.onStopScrolling.cancel();
      this.onMouseEntered.cancel();
    };
    SimpleBarCore2.prototype.unMount = function() {
      this.removeListeners();
    };
    SimpleBarCore2.prototype.isWithinBounds = function(bbox) {
      return this.mouseX >= bbox.left && this.mouseX <= bbox.left + bbox.width && this.mouseY >= bbox.top && this.mouseY <= bbox.top + bbox.height;
    };
    SimpleBarCore2.prototype.findChild = function(el, query) {
      var matches = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
      return Array.prototype.filter.call(el.children, function(child) {
        return matches.call(child, query);
      })[0];
    };
    SimpleBarCore2.rtlHelpers = null;
    SimpleBarCore2.defaultOptions = {
      forceVisible: false,
      clickOnTrack: true,
      scrollbarMinSize: 25,
      scrollbarMaxSize: 0,
      ariaLabel: "scrollable content",
      tabIndex: 0,
      classNames: {
        contentEl: "simplebar-content",
        contentWrapper: "simplebar-content-wrapper",
        offset: "simplebar-offset",
        mask: "simplebar-mask",
        wrapper: "simplebar-wrapper",
        placeholder: "simplebar-placeholder",
        scrollbar: "simplebar-scrollbar",
        track: "simplebar-track",
        heightAutoObserverWrapperEl: "simplebar-height-auto-observer-wrapper",
        heightAutoObserverEl: "simplebar-height-auto-observer",
        visible: "simplebar-visible",
        horizontal: "simplebar-horizontal",
        vertical: "simplebar-vertical",
        hover: "simplebar-hover",
        dragging: "simplebar-dragging",
        scrolling: "simplebar-scrolling",
        scrollable: "simplebar-scrollable",
        mouseEntered: "simplebar-mouse-entered"
      },
      scrollableNode: null,
      contentNode: null,
      autoHide: true
    };
    SimpleBarCore2.getOptions = getOptions;
    SimpleBarCore2.helpers = helpers;
    return SimpleBarCore2;
  })()
);

// node_modules/.pnpm/simplebar@6.3.3/node_modules/simplebar/dist/index.mjs
var extendStatics = function(d, b2) {
  extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b3) {
    d2.__proto__ = b3;
  } || function(d2, b3) {
    for (var p in b3) if (Object.prototype.hasOwnProperty.call(b3, p)) d2[p] = b3[p];
  };
  return extendStatics(d, b2);
};
function __extends(d, b2) {
  if (typeof b2 !== "function" && b2 !== null)
    throw new TypeError("Class extends value " + String(b2) + " is not a constructor or null");
  extendStatics(d, b2);
  function __() {
    this.constructor = d;
  }
  d.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
}
var _a = SimpleBarCore.helpers;
var getOptions2 = _a.getOptions;
var addClasses2 = _a.addClasses;
var canUseDOM2 = _a.canUseDOM;
var SimpleBar = (
  /** @class */
  (function(_super) {
    __extends(SimpleBar2, _super);
    function SimpleBar2() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var _this = _super.apply(this, args) || this;
      SimpleBar2.instances.set(args[0], _this);
      return _this;
    }
    SimpleBar2.initDOMLoadedElements = function() {
      document.removeEventListener("DOMContentLoaded", this.initDOMLoadedElements);
      window.removeEventListener("load", this.initDOMLoadedElements);
      Array.prototype.forEach.call(document.querySelectorAll("[data-simplebar]"), function(el) {
        if (el.getAttribute("data-simplebar") !== "init" && !SimpleBar2.instances.has(el))
          new SimpleBar2(el, getOptions2(el.attributes));
      });
    };
    SimpleBar2.removeObserver = function() {
      var _a2;
      (_a2 = SimpleBar2.globalObserver) === null || _a2 === void 0 ? void 0 : _a2.disconnect();
    };
    SimpleBar2.prototype.initDOM = function() {
      var _this = this;
      var _a2, _b, _c;
      if (!Array.prototype.filter.call(this.el.children, function(child) {
        return child.classList.contains(_this.classNames.wrapper);
      }).length) {
        this.wrapperEl = document.createElement("div");
        this.contentWrapperEl = document.createElement("div");
        this.offsetEl = document.createElement("div");
        this.maskEl = document.createElement("div");
        this.contentEl = document.createElement("div");
        this.placeholderEl = document.createElement("div");
        this.heightAutoObserverWrapperEl = document.createElement("div");
        this.heightAutoObserverEl = document.createElement("div");
        addClasses2(this.wrapperEl, this.classNames.wrapper);
        addClasses2(this.contentWrapperEl, this.classNames.contentWrapper);
        addClasses2(this.offsetEl, this.classNames.offset);
        addClasses2(this.maskEl, this.classNames.mask);
        addClasses2(this.contentEl, this.classNames.contentEl);
        addClasses2(this.placeholderEl, this.classNames.placeholder);
        addClasses2(this.heightAutoObserverWrapperEl, this.classNames.heightAutoObserverWrapperEl);
        addClasses2(this.heightAutoObserverEl, this.classNames.heightAutoObserverEl);
        while (this.el.firstChild) {
          this.contentEl.appendChild(this.el.firstChild);
        }
        this.contentWrapperEl.appendChild(this.contentEl);
        this.offsetEl.appendChild(this.contentWrapperEl);
        this.maskEl.appendChild(this.offsetEl);
        this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl);
        this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl);
        this.wrapperEl.appendChild(this.maskEl);
        this.wrapperEl.appendChild(this.placeholderEl);
        this.el.appendChild(this.wrapperEl);
        (_a2 = this.contentWrapperEl) === null || _a2 === void 0 ? void 0 : _a2.setAttribute("tabindex", this.options.tabIndex.toString());
        (_b = this.contentWrapperEl) === null || _b === void 0 ? void 0 : _b.setAttribute("role", "region");
        (_c = this.contentWrapperEl) === null || _c === void 0 ? void 0 : _c.setAttribute("aria-label", this.options.ariaLabel);
      }
      if (!this.axis.x.track.el || !this.axis.y.track.el) {
        var track = document.createElement("div");
        var scrollbar = document.createElement("div");
        addClasses2(track, this.classNames.track);
        addClasses2(scrollbar, this.classNames.scrollbar);
        track.appendChild(scrollbar);
        this.axis.x.track.el = track.cloneNode(true);
        addClasses2(this.axis.x.track.el, this.classNames.horizontal);
        this.axis.y.track.el = track.cloneNode(true);
        addClasses2(this.axis.y.track.el, this.classNames.vertical);
        this.el.appendChild(this.axis.x.track.el);
        this.el.appendChild(this.axis.y.track.el);
      }
      SimpleBarCore.prototype.initDOM.call(this);
      this.el.setAttribute("data-simplebar", "init");
    };
    SimpleBar2.prototype.unMount = function() {
      SimpleBarCore.prototype.unMount.call(this);
      SimpleBar2.instances["delete"](this.el);
    };
    SimpleBar2.initHtmlApi = function() {
      this.initDOMLoadedElements = this.initDOMLoadedElements.bind(this);
      if (typeof MutationObserver !== "undefined") {
        this.globalObserver = new MutationObserver(SimpleBar2.handleMutations);
        this.globalObserver.observe(document, { childList: true, subtree: true });
      }
      if (document.readyState === "complete" || // @ts-ignore: IE specific
      document.readyState !== "loading" && !document.documentElement.doScroll) {
        window.setTimeout(this.initDOMLoadedElements);
      } else {
        document.addEventListener("DOMContentLoaded", this.initDOMLoadedElements);
        window.addEventListener("load", this.initDOMLoadedElements);
      }
    };
    SimpleBar2.handleMutations = function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(addedNode) {
          if (addedNode.nodeType === 1) {
            if (addedNode.hasAttribute("data-simplebar")) {
              !SimpleBar2.instances.has(addedNode) && document.documentElement.contains(addedNode) && new SimpleBar2(addedNode, getOptions2(addedNode.attributes));
            } else {
              addedNode.querySelectorAll("[data-simplebar]").forEach(function(el) {
                if (el.getAttribute("data-simplebar") !== "init" && !SimpleBar2.instances.has(el) && document.documentElement.contains(el))
                  new SimpleBar2(el, getOptions2(el.attributes));
              });
            }
          }
        });
        mutation.removedNodes.forEach(function(removedNode) {
          var _a2;
          if (removedNode.nodeType === 1) {
            if (removedNode.getAttribute("data-simplebar") === "init") {
              !document.documentElement.contains(removedNode) && ((_a2 = SimpleBar2.instances.get(removedNode)) === null || _a2 === void 0 ? void 0 : _a2.unMount());
            } else {
              Array.prototype.forEach.call(removedNode.querySelectorAll('[data-simplebar="init"]'), function(el) {
                var _a3;
                !document.documentElement.contains(el) && ((_a3 = SimpleBar2.instances.get(el)) === null || _a3 === void 0 ? void 0 : _a3.unMount());
              });
            }
          }
        });
      });
    };
    SimpleBar2.instances = /* @__PURE__ */ new WeakMap();
    return SimpleBar2;
  })(SimpleBarCore)
);
if (canUseDOM2) {
  SimpleBar.initHtmlApi();
}

// src/components/jb-podcast-player/jb-podcast-player.ts
var JbPodcastPlayer = class extends ChangesBackgroundColor(Spaceable(i)) {
  constructor() {
    super(...arguments);
    this.ARIALABELS_DEFAULT = {
      play: "Play",
      pause: "Pause",
      mute: "Mute",
      unmute: "Unmute",
      seek: "Seek",
      volume: "Volume",
      expand: "Expand details",
      collapse: "Collapse details"
    };
    this._currentProgress = 0;
    this._observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          this._sendTracking("visible", { file_progress: "visible" });
          this._observer.unobserve(this);
          this._observer.disconnect();
        }
      });
    });
    this._playerOpen = false;
    this._playingUrl = "";
    this._playlistIndex = 0;
  }
  async firstUpdated() {
    await this.updateComplete;
    this._simpleBar = new SimpleBar(this._playlist, { tabIndex: -1 });
    this._simpleBar.getScrollElement().addEventListener("scroll", this._playlistScrolled.bind(this));
    const controls = `
  <div class="plyr__controls">
    <div class="title">{title}</div>
    <div class="control">
      <div class="plyr__time plyr__time--current" aria-label="Current time">00:00</div>
      <div class="plyr__progress">
          <input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek">
          <span role="tooltip" class="plyr__tooltip">00:00</span>
      </div>
      <div class="plyr__duration-volume__container">
        <div class="duration">
          <div class="plyr__time plyr__time--duration" aria-label="Duration">00:00</div>
        </div>
        <div class="volume__control">
          <button type="button" class="plyr__control" aria-label="Mute" data-plyr="mute">
              <jb-icon class="icon--pressed" iconName="material:volume_off"></jb-icon>
              <jb-icon class="icon--not-pressed" iconName="material:volume_up"></jb-icon>
          </button>
          <div class="plyr__volume">
              <input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume">
          </div>
        </div>
      </div>

      <button type="button" class="plyr__control" data-plyr="play">
          <jb-icon class="pause" iconName="material:pause-fill"></jb-icon>
          <jb-icon class="play" iconName="material:play_arrow-fill"></jb-icon>

          <span class="label--pressed plyr__tooltip" role="tooltip">Pause</span>
          <span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span>
      </button>
    </div>
  </div>
`;
    this._plyr = new Plyr(this._audioPlayer, {
      controls,
      loadSprite: false,
      i18n: {
        mute: this.ariaLabels?.mute ?? this.ARIALABELS_DEFAULT.mute,
        unmute: this.ariaLabels?.unmute ?? this.ARIALABELS_DEFAULT.unmute,
        pause: this.ariaLabels?.pause ?? this.ARIALABELS_DEFAULT.pause,
        play: this.ariaLabels?.play ?? this.ARIALABELS_DEFAULT.play,
        seek: this.ariaLabels?.seek ?? this.ARIALABELS_DEFAULT.seek,
        volume: this.ariaLabels?.volume ?? this.ARIALABELS_DEFAULT.volume
      }
    });
    this._plyr.on("ready", (evt) => {
      const progressBar = evt.detail.plyr.elements.controls.querySelector(".plyr__progress");
      const progressBarRangeInput = progressBar.querySelector('input[type="range"]');
      this.style.setProperty("--playerheight", this._plyr.elements.container.offsetHeight + "px");
      new import_rangetouch.default(progressBarRangeInput, {});
      progressBar.addEventListener("touchstart", () => {
        evt.detail.plyr.elements.container.setAttribute("data-seeking", "");
      });
      progressBar.addEventListener("touchend", () => {
        evt.detail.plyr.elements.container.removeAttribute("data-seeking");
      });
      progressBar.addEventListener("mousedown", () => {
        evt.detail.plyr.elements.container.setAttribute("data-seeking", "");
      });
      progressBar.addEventListener("mouseup", () => {
        evt.detail.plyr.elements.container.removeAttribute("data-seeking");
      });
    });
    this._plyr.on("timeupdate", (evt) => {
      const currentTime = evt.detail.plyr.currentTime || 0;
      const currentDuration = evt.detail.plyr.duration;
      const currentPercentage = currentDuration > 0 ? Math.round(currentTime / currentDuration * 10) * 10 : 0;
      if (currentPercentage > this._currentProgress) {
        this._currentProgress = currentPercentage;
        this._sendTracking("progress", {
          file_progress: this._currentProgress + "%",
          file_type: this._playingUrl.split(".").pop()
        });
      }
      const currentProgress = Math.floor(evt.detail.plyr.currentTime * 100 / evt.detail.plyr.duration);
      if (typeof currentProgress !== "number" || !this._playingElement) return;
      const progressElement = this._playingElement.querySelector(".progress > input");
      progressElement.style.setProperty("--value", Number.isNaN(currentProgress) ? "0" : currentProgress + "%");
      progressElement.value = String(currentProgress);
    });
    this._plyr.on("playing", (evt) => {
      this._simpleBar.recalculate();
      const listPlayButton = this._playingElement.querySelector(".playbackbutton");
      this._playingElement.dataset.playing = "";
      evt.detail.plyr.elements.buttons.play[0].classList.remove("loading");
      evt.detail.plyr.elements.container.setAttribute("data-playing", "");
      listPlayButton.classList.remove("loading");
      listPlayButton.ariaPressed = "true";
      listPlayButton.ariaLabel = this.ariaLabels?.pause ?? this.ARIALABELS_DEFAULT.pause;
    });
    this._plyr.on("pause", (evt) => {
      evt.detail.plyr.elements.container.removeAttribute("data-playing");
      this._playingElement.removeAttribute("data-playing");
      const listPlayButton = this._playingElement.querySelector(".playbackbutton");
      listPlayButton.ariaPressed = "false";
      listPlayButton.ariaLabel = this.ariaLabels?.play ?? this.ARIALABELS_DEFAULT.play;
    });
    this._plyr.on("loadstart", (evt) => {
      this._playlist.querySelector('[aria-pressed="true"]')?.setAttribute("aria-pressed", "false");
      if (this._playingUrl === "") return;
      this._playingElement.querySelector(".playbackbutton").classList.add("loading");
      const range = this._playingElement.querySelector('[type="range"]');
      range.value = "0";
      evt.detail.plyr.elements.buttons.play[0].classList.add("loading");
    });
    window.addEventListener("resize", () => {
      this.style.setProperty("--playerheight", this._plyr.elements.container.offsetHeight + "px");
    });
    this._observer.observe(this);
  }
  _getContentSpacingProperties() {
    return { grid: true, colsMdUp: 8 };
  }
  _handleAccordionToggle(evt) {
    const expandButton = evt.currentTarget;
    const detailsItem = evt.currentTarget.closest("[data-details]");
    const episodeItem = detailsItem.closest("[data-podcasturl]");
    const accordeonItem = episodeItem.querySelector("[data-description]");
    if (detailsItem.getAttribute("open") === null) {
      this._trackAccordionToggle(episodeItem.dataset.podcastheadline);
    }
    detailsItem.toggleAttribute("open");
    expandButton.setAttribute(
      "aria-expanded",
      expandButton.getAttribute("aria-expanded") === "false" ? "true" : "false"
    );
    expandButton.setAttribute(
      "aria-label",
      expandButton.getAttribute("aria-expanded") === "true" ? this.ariaLabels?.collapse ?? this.ARIALABELS_DEFAULT.collapse : this.ariaLabels?.expand ?? this.ARIALABELS_DEFAULT.expand
    );
    accordeonItem.toggleAttribute("inert");
    this._playlistIndex = parseInt(episodeItem.dataset.index, 10);
  }
  _handleKeydownOnPlayer(evt) {
    const validButtons = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", " "];
    if (!validButtons.includes(evt.key)) return;
    evt.preventDefault();
    switch (evt.key) {
      case "ArrowUp":
        this._plyr.increaseVolume(0.1);
        break;
      case "ArrowDown":
        this._plyr.decreaseVolume(0.1);
        break;
      case "ArrowLeft":
        this._plyr.rewind(1);
        break;
      case "ArrowRight":
        this._plyr.forward(1);
        break;
      case " ":
        this._plyr.togglePlay();
        break;
      default:
        break;
    }
  }
  _handleKeydownOnPlayList(evt) {
    const validButtons = ["ArrowUp", "ArrowDown"];
    if (!validButtons.includes(evt.key)) return;
    evt.preventDefault();
    const buttonType = evt.target.dataset.controlbutton;
    const playlistElements = this._playlist.querySelectorAll("[data-podcasturl]");
    switch (evt.key) {
      case "End":
        evt.preventDefault();
        this._playlistIndex = playlistElements.length - 1;
        break;
      case "Home":
        evt.preventDefault();
        this._playlistIndex = 0;
        break;
      case "ArrowUp":
        if (this._playlistIndex > 0) this._playlistIndex -= 1;
        break;
      case "ArrowDown":
        if (this._playlistIndex < playlistElements.length - 1) this._playlistIndex += 1;
        break;
      default:
        break;
    }
    const nextButton = playlistElements[this._playlistIndex].querySelector(
      `[data-controlbutton="${buttonType}"]`
    );
    nextButton?.focus();
    this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
  }
  _playlistScrolled(evt) {
    const target = evt.currentTarget;
    this._isScrolledTop = target.scrollTop > 0;
    this._isScrolledBottom = target.scrollHeight - (target.scrollTop + target.offsetHeight) === 0;
  }
  _progressSliderChange(evt) {
    const inpt = evt.target;
    inpt.style.setProperty("--value", inpt.value ?? "0%");
  }
  _progressSliderMouseDown() {
    this._plyr.pause();
  }
  _progressSliderMouseUp(evt) {
    const inpt = evt.target;
    this._plyr.currentTime = this._plyr.duration * parseFloat(inpt.value) / 100;
    this._plyr.play();
  }
  _sendTracking(interaction_type, additionalInfo) {
    const trackingDetails = {
      event: "ce_audio",
      event_version: "v2",
      component_name: "podcast-player",
      file_name: this._playingUrl !== "" ? `${this.headline}: ${this._playingElement.dataset.podcastheadline}` : this.headline,
      interaction_type,
      ...additionalInfo
    };
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: trackingDetails,
        bubbles: true,
        composed: true
      })
    );
  }
  _togglePlay(evt) {
    this._playlist.querySelector(".loading")?.classList.remove("loading");
    this._plyr.elements.buttons.play[0].classList.remove("loading");
    const activeLiElement = evt.currentTarget.closest("[data-podcasturl]");
    evt.stopImmediatePropagation();
    if (typeof activeLiElement.dataset.active === "undefined") {
      if (typeof this._playingElement?.dataset.active !== "undefined") {
        this._playingElement.removeAttribute("data-active");
        this._playingElement.removeAttribute("data-playing");
        const prog = this._playingElement.querySelector("input[type=range]");
        prog.removeEventListener("input", this._progressSliderChange);
        prog.removeEventListener("mousedown", this._progressSliderMouseDown.bind(this));
        prog.removeEventListener("mouseup", this._progressSliderMouseUp.bind(this));
        prog.removeEventListener("touchstart", this._progressSliderMouseDown.bind(this));
        prog.removeEventListener("touchend", this._progressSliderMouseUp.bind(this));
        prog.setAttribute("tabindex", "-1");
      }
      this._playingElement = activeLiElement;
      this._playingElement.dataset.active = "";
      const newProg = this._playingElement.querySelector("input[type=range]");
      newProg.addEventListener("input", this._progressSliderChange);
      newProg.addEventListener("mousedown", this._progressSliderMouseDown.bind(this));
      newProg.addEventListener("mouseup", this._progressSliderMouseUp.bind(this));
      newProg.addEventListener("touchstart", this._progressSliderMouseDown.bind(this));
      newProg.addEventListener("touchend", this._progressSliderMouseUp.bind(this));
      newProg.setAttribute("tabindex", "0");
      this._playingUrl = this._playingElement.dataset.podcasturl;
      this._plyr.source = {
        type: "audio",
        title: this._playingElement.dataset.podcastheadline,
        sources: [{ src: this._playingUrl, type: "audio/mp3" }]
      };
      this._plyr.once("canplay", () => {
        this._plyr.play();
      });
      this._plyr.elements.container.style.setProperty("--podcastdate", `"${this._playingElement.dataset.podcastdate}"`);
      this._plyr.elements.container.style.setProperty(
        "--podcastduration",
        `"${this._playingElement.dataset.podcastduration}"`
      );
      this.style.setProperty("--playerheight", this._plyr.elements.container.offsetHeight + "px");
      this._sendTracking("start", {
        file_type: this._playingUrl.split(".").pop(),
        file_progress: "start"
      });
    } else {
      this._plyr.togglePlay();
    }
  }
  _trackAccordionToggle(podcastHeadline) {
    this._sendTracking("expand", {
      file_name: `${this.headline}: ${podcastHeadline}`
    });
  }
  _trackSubscription(evt) {
    const link = evt.currentTarget;
    evt.stopImmediatePropagation();
    this._sendTracking("subscribe", {
      interaction_text: link.title,
      interaction_result: link.href
    });
  }
  render() {
    return b`
      <div ?data-playeropen=${this._playingUrl !== ""}>
        <header class="${e2({ scrolledtop: this._isScrolledTop, main: true })}">
          <jb-picture
            .alt=${this.image.alt}
            .imgData=${this.image.imgData}
            aspect="aspect_1by1"
          ></jb-picture>
          <div>
            ${this.headline ? b`<jb-heading>${this.headline}</jb-heading>` : A}
            <p>${o(this.subline)}</p>
          </div>
        </header>

        <div
          class="playlist"
          @keydown=${this._handleKeydownOnPlayList}
          data-fly-container
        >
          ${this.episodes.map((episode, index) => {
      const uniqueId = Math.random().toString(36).substr(2, 9);
      return b`
              <div
                data-podcasturl="${episode.url}"
                data-podcastheadline="${episode.headline}"
                data-podcastdate="${episode.date}"
                data-podcastduration="${episode.duration} ${episode.minuteLabel}"
                data-index="${index}"
              >
                <div
                  class="details"
                  data-details
                >
                  <div class="summary">
                    <jb-heading
                      class="sr-only"
                      .offset=${this.headline ? 1 : 0}
                      >${episode.date} ${episode.headline}</jb-heading
                    >
                    <div
                      class="info"
                      aria-hidden="true"
                    >
                      <div class="date">${episode.date}</div>
                      <div class="headline">${o(episode.headline)}</div>
                    </div>
                    <div class="control">
                      <div class="date">${episode.date}</div>
                      <div
                        class="progress"
                        @keydown=${(evt) => {
        evt.stopPropagation();
        this._handleKeydownOnPlayer(evt);
      }}
                      >
                        <input
                          data-plyr="seek"
                          type="range"
                          min="0"
                          max="100"
                          step="0.01"
                          value="0"
                          aria-hidden="${this._playingUrl && this._playingUrl === episode.url ? "false" : "true"}"
                          aria-label="${this.ariaLabels?.seek ?? this.ARIALABELS_DEFAULT.seek}"
                          style="--value: 0%"
                          tabindex="-1"
                        />
                      </div>
                      <div class="duration">${episode.duration} ${episode.minuteLabel}</div>
                      <button
                        aria-label="${this.ariaLabels?.play ?? this.ARIALABELS_DEFAULT.play}"
                        aria-pressed="false"
                        class="playbackbutton"
                        data-controlbutton="playbackbutton"
                        @click=${this._togglePlay}
                        tabindex="${this._playlistIndex === index || this._playingUrl === episode.url ? "0" : "-1"}"
                        type="button"
                      >
                        <div class="isplaying"><jb-icon iconName="material:pause-fill"></jb-icon></div>
                        <div class="ispaused"><jb-icon iconName="material:play_arrow-fill"></jb-icon></div>
                      </button>
                      <button
                        @click=${this._handleAccordionToggle}
                        class="accordiontogglebutton"
                        data-controlbutton="accordiontogglebutton"
                        type="button"
                        tabindex="${this._playlistIndex === index || this._playingUrl === episode.url ? "0" : "-1"}"
                        aria-expanded="false"
                        aria-controls="episode-description-${uniqueId}"
                        aria-label="${this.ariaLabels?.expand ?? this.ARIALABELS_DEFAULT.expand}"
                      >
                        <div class="accordiontoggle">
                          <jb-icon
                            iconName="material:keyboard_arrow_down"
                            size="small"
                          ></jb-icon>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  id="episode-description-${uniqueId}"
                  class="description"
                  data-description
                  inert
                >
                  <div>${o(episode.text)}</div>
                </div>
              </div>
            `;
    })}
        </div>
        <div class="bottom">
          <div
            id="player"
            class="${e2({ scrolledbottom: !this._isScrolledBottom })}"
            ?inert=${this._playingUrl === "" ? true : A}
            @keydown=${this._handleKeydownOnPlayer}
          >
            <audio controls>
              <source
                .src=${this._playingUrl}
                type="audio/mp3"
              />
            </audio>
          </div>
          <footer>
            <span>${this.allEpisodesText}</span>
            <ul role="${this.providerBadges.length === 1 ? "presentation" : A}">
              ${this.providerBadges.map(
      (providerBadge) => b`
                  <li role="${this.providerBadges.length === 1 ? "presentation" : A}">
                    <a
                      title="${providerBadge.name}"
                      aria-label="${providerBadge.ariaLabels?.label || providerBadge.name}"
                      href="${providerBadge.link.href || "#"}"
                      target="${providerBadge.link.target || "_self"}"
                      ?download=${providerBadge.link.download || false}
                      @click=${this._trackSubscription}
                    >
                      <jb-picture
                        .imgData=${providerBadge.badgeImage.imgData}
                        alt="${providerBadge.name}"
                      ></jb-picture>
                    </a>
                  </li>
                `
    )}
            </ul>
          </footer>
        </div>
      </div>
    `;
  }
};
JbPodcastPlayer.styles = [reset_css_default, jb_podcast_player_css_default];
__decorateClass([
  n()
], JbPodcastPlayer.prototype, "allEpisodesText", 2);
__decorateClass([
  n({ type: Object })
], JbPodcastPlayer.prototype, "ariaLabels", 2);
__decorateClass([
  n({ type: Array })
], JbPodcastPlayer.prototype, "episodes", 2);
__decorateClass([
  n({ reflect: true })
], JbPodcastPlayer.prototype, "headline", 2);
__decorateClass([
  n({ type: Object })
], JbPodcastPlayer.prototype, "image", 2);
__decorateClass([
  n({ type: Array })
], JbPodcastPlayer.prototype, "providerBadges", 2);
__decorateClass([
  n()
], JbPodcastPlayer.prototype, "subline", 2);
__decorateClass([
  e("audio")
], JbPodcastPlayer.prototype, "_audioPlayer", 2);
__decorateClass([
  r()
], JbPodcastPlayer.prototype, "_currentProgress", 2);
__decorateClass([
  r()
], JbPodcastPlayer.prototype, "_isScrolledBottom", 2);
__decorateClass([
  r()
], JbPodcastPlayer.prototype, "_isScrolledTop", 2);
__decorateClass([
  r()
], JbPodcastPlayer.prototype, "_playerOpen", 2);
__decorateClass([
  r()
], JbPodcastPlayer.prototype, "_playingUrl", 2);
__decorateClass([
  e(".playlist")
], JbPodcastPlayer.prototype, "_playlist", 2);
__decorateClass([
  r()
], JbPodcastPlayer.prototype, "_playlistIndex", 2);
JbPodcastPlayer = __decorateClass([
  customElement("jb-podcast-player")
], JbPodcastPlayer);

export {
  JbPodcastPlayer
};
